import { LineShopNormalEventPayload } from '@/methods/lineshop/types'

import { getLineShopTrackingClient } from './client'

const ENDPOINT = '/v1/lineshop/tracking/events/normal'

export const sendNormalEvent = (payload: LineShopNormalEventPayload) => getLineShopTrackingClient().post(ENDPOINT, payload)
